import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconInsights = () => {
  return (
    <g>
      <path
        d="M9.134.003h-5.29c-.318 0-.601.198-.709.495L.045 9.012l-.028.098c-.1.459.25.91.737.91l2.51-.001-1.566 4.368c-.158.522.02 1.036.424 1.344a1.35 1.35 0 0 0 1.771-.128l7.951-10.387.06-.089a.752.752 0 0 0-.66-1.118H8.472L9.82 1.066A.752.752 0 0 0 9.134.003zM7.96 1.505 6.613 4.449l-.036.094a.752.752 0 0 0 .722.97l2.423-.001-6.101 7.976L5.046 9.52l.028-.098a.752.752 0 0 0-.738-.907H1.828l2.544-7.011h3.589z"
        
      />
    </g>
  );
};

export default withIcon(IconInsights);
